import request from "../../../utils/request";
import dayjs from "dayjs";

export const getContracts = '/contract/get';

// Method: POST
export const getContractsDict = '/contract/dict';
export const exportContracts = '/contract/export';
export const getAllContractPrices = '/contract/getAllContractPrices'
export const exportPrices = '/contract/exportAllContractPrices'
export function getContractById(id: number) {
    return request.get('/contract/getContract', {params: {id}});
}

export function modifyContract(value: any) {
    return request.request({
            url: '/contract/',
            method: value.id ? 'put' : 'post',
            data: value,
        }
    )
}

export function revisionContract(values: any) {
    return request.post('/contract/revision', values);
}

export function updateVersion(id: any, values: any) {
    return request.post('/contract/version/update?id=' + id, values);
}

export function getContractVersions(contractId: number) {
    return request.get('/contract/versions', {params: {contractId}});
}

export function getContractVersion(id: number) {
    return request.get('/contract/version', {params: {id}});
}

export function getExistContract(params: any) {
    return request.get('/contract/exist', {
        params:params
    });
}

export function toOA(versionId:any){
    return request.post('/contract/version/toOA', {versionId});
}

export function importContract(file: File){
    const formData = new FormData();
    formData.append("file", file);
    return request.post('/contract/importContract', formData);
}

export function importProduct(file:File){
    const formData = new FormData();
    formData.append("file", file);
    return request.post('/contract/importProduct', formData);
}

export function importGiveaways(file:File){
    const formData = new FormData();
    formData.append("file", file);
    return request.post('/contract/importGiveaways', formData);
}

export function importProductPrice(file:File){
    const formData = new FormData();
    formData.append("file", file);
    return request.post('/contract/importProductPrice', formData);
}

export function deleteContract(id: any) {
    return request.delete('/contract/', {params:{id}});
}


//TODO:测试接口,待删除
export function acceptVersion(versionId: any) {
    const value: any = {id: versionId};
    value.status = 1
    value.approveBy = 'Test'
    value.approveDate = dayjs(Date.now())
    value.approveCode = Math.random().toString(16).substring(2)
    return request.post('/contract/version/accept', value)
}

//TODO:测试接口,待删除
export function rejectVersion(versionId: any) {
    const value: any = {id: versionId};
    value.status = 3
    value.approveBy = 'Test'
    value.approveDate = dayjs(Date.now())
    value.approveCode = Math.random().toString(16).substring(2)
    return request.post('/contract/version/reject', value)
}


export function duplicateContract(data: any){
    return request.post('/contract/duplicate', data);
}